<template>
  <div>
    <div class="page-wrapper profile-summary" style="padding-top: 0px;">
      <div class="container">
        <div class="top-wrap">
          <div class="page-heading">
            <h1 class="page-title">{{ club.clubName }}</h1>
            <div class="extra-view">
              <a-button
                v-if="!this.$route.params.id && onlyClubCoach()"
                type="primary"
                icon="usergroup-add"
                >Profile Views- {{ club.views }}</a-button
              >
              <div
                class="fav-click"
                @click="changeFav"
                :class="{ isfav: checkedFavourite.isFav }"
                v-else
              >
                <a-icon type="heart" class="outline" theme="outlined" />
                <a-icon type="heart" class="fill" theme="filled" />
              </div>
            </div>
          </div>
          <a-alert
            class="margin-bottom-1"
            type="info"
            show-icon
            v-if="onlyClubHeadCoach()"
            closable
          >
            <span slot="message"
              >You are currently enjoying our free BASIC Profile. To learn about
              our PREMIUM features and pricing please click
              <a
                class="black-bold"
                :href="`/${$route.params.profileId}/pricing-detail`"
                >HERE</a
              ></span
            >
          </a-alert>
          <a-alert
            class="margin-bottom-1"
            type="info"
            show-icon
            v-if="onlyClubHeadCoach()"
            closable
          >
            <span slot="message">
              If you are already familiar with the PREMIUM feature and price,
              upgrade your profile from
              <a
                class="black-bold"
                :href="
                  `/${$route.params.profileId}/transaction-history?name=${userName}`
                "
                >My Account</a
              >
              section</span
            ></a-alert
          >
        </div>
        <!-- content -->
        <div class="content">
          <Sliders
            :logo-image="generateImageUrl(club.logo)"
            :slider-images="
              club.background &&
                club.background.map(item => generateImageUrl(item))
            "
            :social="{
              facebook: club.facebook,
              twitter: club.twitter,
              instagram: club.instagram,
              linkedin: club.linkedin,
              flickr: club.flickr,
              youtube: club.youtube,
              podcast: club.podcast
            }"
          />
          <div class="tab-section">
            <a-tabs
              default-active-key="1"
              tab-position="left"
              class="summary-basic-tabs"
            >
              <a-tab-pane key="1" tab="Club Details">
                <a-row :gutter="24">
                  <a-col :lg="12">
                    <div class="box">
                      <div class="box-header">
                        <h2 class="box-title">Basic information</h2>
                      </div>
                      <div class="box-body">
                        <table class="table table-striped">
                          <thead></thead>
                          <tbody>
                            <tr>
                              <th scope="row">Name:</th>
                              <td>{{ club.clubName }}</td>
                            </tr>
                            <tr>
                              <th scope="row">Phone</th>
                              <td>{{ club.clubPhone }}</td>
                            </tr>
                            <tr>
                              <th scope="row">Website URL:</th>
                              <td class="break-all">{{ club.url }}</td>
                            </tr>
                            <tr>
                              <th scope="row">Age Group :</th>
                              <td>{{ club.ageGroup }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </a-col>
                  <a-col :lg="12">
                    <div class="box">
                      <div class="box-header">
                        <h2 class="box-title">More Information</h2>
                      </div>
                      <div class="box-body">
                        <table class="table table-striped">
                          <thead></thead>
                          <tbody>
                            <tr>
                              <th scope="row">City/State/Zip:</th>
                              <td>
                                {{ club.city ? `${club.city}` : "-" }}
                                / {{ club.state ? `${club.state}` : "-" }} /
                                {{ club.zip ? `${club.zip}` : "" }}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Address:</th>
                              <td>
                                {{ club.address1 ? club.address1 : "-" }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </a-col>
                </a-row>
              </a-tab-pane>
              <a-tab-pane key="2" tab="Description">
                <a-row :gutter="24">
                  <a-col :sm="24">
                    <div class="box">
                      <div class="box-header">
                        <h2 class="box-title">Description</h2>
                      </div>
                      <div class="box-body">
                        <p class="pre-line">{{ club.description }}</p>
                      </div>
                    </div>
                  </a-col>
                </a-row>
              </a-tab-pane>
              <a-tab-pane key="3" tab="Additional Information">
                <a-row :gutter="24">
                  <a-col :sm="24">
                    <div class="box">
                      <div class="box-header">
                        <h2 class="box-title">Additional Information</h2>
                      </div>
                      <div class="box-body">
                        <p class="w-space-preline">{{ club.info }}</p>
                      </div>
                    </div>
                  </a-col>
                </a-row>
              </a-tab-pane>
              <a-tab-pane key="4" tab="Team Highlights">
                <a-row :gutter="24">
                  <a-col :sm="24">
                    <div class="box">
                      <div class="box-header">
                        <h2 class="box-title">Team Highlights</h2>
                      </div>
                      <div
                        class="box-body"
                        v-match-heights="{
                          el: ['.box-body', '.image', '.a-col'],
                          disabled: [575]
                        }"
                      >
                        <a-row :gutter="24">
                          <a-col
                            :sm="8"
                            v-for="(clubTeamHighlight,
                            index) in clubTeamHighlightsLimited"
                            :key="index"
                            @click="goToHighlightDetail(clubTeamHighlight.id)"
                          >
                            <figure class="thumbnail text-center">
                              <img
                                class="image"
                                :src="generateImageUrl(clubTeamHighlight.image)"
                              />
                              <a class="font-weight-bold color-secondary">
                                {{ clubTeamHighlight.title }}
                              </a>
                            </figure>
                          </a-col>
                        </a-row>
                      </div>
                      <div
                        class="highlights-footer text-center padding-b-10px"
                        v-if="!_.isEmpty(clubTeamHighlightsLimited)"
                      >
                        <a-button
                          type="primary"
                          @click="
                            goToRoute(
                              `${
                                $route.params.id
                                  ? `/${profileId}/club_profile/${$route.params.id}/team_highlights`
                                  : `/${profileId}/club_profile/team_highlights`
                              }`
                            )
                          "
                          class="view-text "
                        >
                          View More
                          <i
                            class="fa fa-angle-double-right"
                            aria-hidden="true"
                            style="margin-left:10px"
                          ></i>
                        </a-button>
                      </div>
                    </div>
                  </a-col>
                </a-row>
              </a-tab-pane>
            </a-tabs>
          </div>
        </div>
        <!-- /.content -->
        <!-- /.page-wrapper -->
      </div>
      <!-- /.container -->
      <!-- Sections  coaching-team-->
      <section class="coaching-team content">
        <div class="container">
          <div class="main-heading text-center">
            <h2>Coaching Staff</h2>
            <p v-if="_.isEmpty(coaches)">
              No Data Available !
            </p>
          </div>
          <!-- row1 -->
          <a-row :gutter="24">
            <a-col
              :sm="12"
              :lg="8"
              v-for="(coach, index) in coaches"
              :key="index"
            >
              <div
                class="section box"
                v-match-heights="{
                  el: ['.company-content', '.box .box-header', '.event-footer'],
                  disabled: [575]
                }"
              >
                <div class="box-header d-flex-spc-btwn">
                  <span class="box-title coach-name-wrapper">
                    {{ coach.coachname }}
                  </span>
                  <a-dropdown
                    v-if="canComplain && coach.lastLogin"
                    placement="bottomRight"
                    :trigger="['click']"
                  >
                    <a-icon class="dropdown-icon pointer-hover" type="more" />
                    <a-menu slot="overlay">
                      <a-menu-item>
                        <a @click="reportCoach(coach)">Report Coach</a>
                      </a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </div>
                <div class="box-body">
                  <!-- event-box -->
                  <div class="event-box">
                    <div class="company-content">
                      <!-- Left-aligned media object -->
                      <div class="media">
                        <div class="main-heading">
                          <h2>{{ coach.position }}</h2>
                        </div>
                        <div class="media-body">
                          <div class="media-left">
                            <img
                              :src="generateImageUrl(coach.image)"
                              class="media-object"
                            />
                          </div>
                          <div class="media-description">
                            <p class="w-space-preline">
                              {{ coach.description }}
                            </p>
                            <span style="font-weight:700">
                              <a
                                class="color-secondary"
                                @click="
                                  goToRoute(
                                    `/${profileId}/club/coaching_staffs/${coach.id}/details`
                                  )
                                "
                                >FULL BIO</a
                              >
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /.company-content -->
                    <div class="event-footer">
                      <button
                        type="button"
                        class="btn btn-default"
                        v-if="
                          coach.lastLogin &&
                            coach.id !== profileId &&
                            !coachIsDeactivated(coach)
                        "
                        @click="handleConnect(coach.id, coach.uniqueSlug)"
                      >
                        {{ coach.isConnected ? "Message" : "Connect" }}
                      </button>
                      <div
                        v-else-if="coach.lastLogin && coachIsDeactivated(coach)"
                      >
                        <p
                          class="chat-connect-info"
                          v-if="coach.contactIsIgnored"
                        >
                          You have ignored this user. Go to your ignored list
                          and chat with this user.
                        </p>
                        <p
                          class="chat-connect-info"
                          v-else-if="coach.isContactSaved"
                        >
                          You have saved this user. Go to your saved list and
                          chat with this user.
                        </p>
                        <p class="chat-connect-info" v-else>
                          You have blocked this user. Go to your chat screen and
                          unblock this user first.
                        </p>
                      </div>
                      
                      <div v-else-if="!coach.lastLogin">
                         <p class="chat-connect-info">
                          This coach is not available for connection yet.
                        </p>
                      </div>
                    </div>
                  </div>
                  <!-- /.event-box -->
                </div>
                <!-- /.box-body -->
              </div>
            </a-col>
          </a-row>
        </div>
      </section>
      <!-- /.sections  /.coaching-team-->
      <Videos
        :video-data="limitedVideos"
        @view-all="
          goToRoute(
            `${
              $route.params.id
                ? `/${profileId}/club_profile/${$route.params.id}/listing/videos`
                : `/${profileId}/club_profile/listing/videos`
            }`
          )
        "
      ></Videos>
      <!-- Sections  latest-video-->
        <Events
        title="Upcoming Team Events"
        type="club"
        :event-data="clubEventsLimitedV1"
        :participatingEvents ="clubEventsLimitedV1"
        @view-all="
          goToRoute(
            `${
              $route.params.id
                ? `/${profileId}/club_profile/${$route.params.id}/events`
                : `/${profileId}/club_profile/events`
            }`
          )
        "
      ></Events>
        <Events
        title="Upcoming Promoted Events"
        type="club"
        :event-data="clubEventsLimited"
        :participatingEvents ="clubEventsLimited"
        @view-all="
          goToRoute(
            `${
              $route.params.id
                ? `/${profileId}/club_profile/${$route.params.id}/events`
                : `/${profileId}/club_profile/events`
            }`
          )
        "
      ></Events>

      <Roster
        @view-all="
          goToRoute(
            `${
              $route.params.id
                ? `/${profileId}/club_profile/${$route.params.id}/roster`
                : `/${profileId}/club_profile/roster`
            }`
          )
        "
      />
    </div>
  </div>
</template>
<script>
import Sliders from "@/views/commonprofile/slider";
import Videos from "@/views/commonprofile/video";
import Events from "@/views/commonprofile/event";
import Roster from "@/views/commonprofile/roster";
import { mapGetters } from "vuex";
import { Chat } from "@/models";

const STORE_KEY = "clubStore";
const HIGHLIGHT_STORE_KEY = "clubTeamHighlightStore";
const COACH_STORE_KEY = "coachStore";
const EVENT_STORE_KEY = "clubEventStore";
const CHAT_STORE_KEY = "chatStore";
const FAVOURITE_STORE_KEY = "favouriteStore";
const ROSTER_STORE_KEY = "rosterStore";

export default {
  name: "Summary",
  components: {
    Sliders,
    Videos,
    Events,
    Roster
  },
  computed: {
    ...mapGetters({
      club: `${STORE_KEY}/club`,
      clubLoading: `${STORE_KEY}/clubLoading`,
      clubTeamHighlightsLimited: `${HIGHLIGHT_STORE_KEY}/clubTeamHighlightsLimited`,
      coaches: `${COACH_STORE_KEY}/coaches`,
      limitedVideos: `${STORE_KEY}/limitedVideos`,
      clubEventsLimited: `${EVENT_STORE_KEY}/clubEventsLimited`,
      clubEventsLimitedV1: `${EVENT_STORE_KEY}/clubEventsLimitedV1`,
      checkedFavourite: `${FAVOURITE_STORE_KEY}/checkedFavourite`
    }),
    clubId() {
      return this.$route.params.id || localStorage["club-id"];
    },
    userName() {
      return JSON.parse(localStorage["user-name"]);
    },
    canComplain() {
      return (
        this.exceptBasicPlayer() && Chat.userType().toLowerCase() === "athlete"
      );
    },
    currentDate() {
      const currentDate = new Date();
      const month = `0${currentDate.getMonth() + 1}`;
      return `${currentDate.getFullYear()}/${
        month.length === 2
          ? month
          : `${month.split("")[1]}${month.split("")[2]}`
      }/${currentDate.getDate()}`;
    },
    profileId() {
      return Chat.profileId();
    }
  },
  async created() {
    await this.$store.dispatch(`${STORE_KEY}/getClub`, {
      id: this.clubId
    });
    await this.$store.dispatch(`${ROSTER_STORE_KEY}/clearLimitedRosterData`);
    if (!this.club.coachDowngraded) {
      await this.$store.dispatch(`${ROSTER_STORE_KEY}/getRosterListLimited`, {
        clubId: this.clubId,
        isActive: true,
        limit: 4,
        page: 1
      });
    }
    this.$store.dispatch(
      `${HIGHLIGHT_STORE_KEY}/getClubTeamHighlightsLimited`,
      {
        id: this.clubId,
        limit: 3,
        page: 1
      }
    );
    this.$store.dispatch(`${COACH_STORE_KEY}/getCoaches`, {
      resourceType: "clubcoach",
      sort: "createdAt",
      clubId: this.clubId,
      fields: "clubName,coachname,position,uniqueSlug,role,image"
    });
    this.$store.dispatch(`${STORE_KEY}/getLimitedVideos`, {
      id: this.clubId,
      limit: 3
    });
    this.$store.dispatch(`${EVENT_STORE_KEY}/getClubEventsLimitedV1`, {
      clubId: this.clubId,
      limit: 4,
      page: 1,
      "date[gte]": this.currentDate,
      sort: "date",
      displayOnProfile:false

    });
    this.$store.dispatch(`${EVENT_STORE_KEY}/getClubEventsLimited`, {
      clubId: this.clubId,
      limit: 4,
      page: 1,
      "date[gte]": this.currentDate,
      sort: "date",
      displayOnProfile:true

    });
    this.$store.dispatch(`${FAVOURITE_STORE_KEY}/checkFavourite`, {
      id: this.clubId
    });
  },
  methods: {
    goToRoute(route) {
      this.$router.push(route);
    },
    reportCoach(coach) {
      let route = `/${this.profileId}/complain`;
      sessionStorage["coach-id"] = coach.id;
      sessionStorage["coach-type"] = coach.uniqueSlug;
      sessionStorage["coach-name"] = coach.name;
      this.$router.push({
        path: route
      });
    },
    handleConnect(coachId, coachType) {
      const receiverInfo = btoa(
        JSON.stringify({
          receiver_id: coachId,
          receiver_type: Chat.receiverType(coachType)
        })
      );
      this.$router.push({
        path: `/${this.profileId}/chat/${receiverInfo}`
      });
    },
    async changeFav() {
      if (this.checkedFavourite.isFav) {
        await this.$store.dispatch(`${FAVOURITE_STORE_KEY}/deleteFavourite`, {
          favBy: Chat.profileId(),
          favTo: this.clubId
        });
        this.$store.dispatch(`${FAVOURITE_STORE_KEY}/unsetCheckedFavourite`);
        return;
      }
      await this.$store.dispatch(`${FAVOURITE_STORE_KEY}/createFavourite`, {
        favBy: Chat.profileId(),
        favTo: this.clubId,
        typeFav: "clubTeam"
      });
      this.$store.dispatch(`${FAVOURITE_STORE_KEY}/setCheckedFavourite`);
    },
    goToHighlightDetail(id) {
      this.$router.push(
        `/${this.profileId}/club/${this.clubId}/team_highlights/${id}/show`
      );
    },
    coachIsDeactivated(coach) {
      return (
        (coach.isConnected && coach.contactIsIgnored) ||
        (coach.isConnected && coach.contactIsBlocked) ||
        (coach.isConnected && coach.isContactSaved)
      );
    }
  }
};
</script>

<style lang="sass">
.summary-basic-tabs
  .ant-tabs-nav
    .ant-tabs-tab
      display: block !important
.coach-name-wrapper
  margin-top: 0.2rem
.dropdown-icon
  padding: 0.3rem
</style>

<style lang="scss">
.pre-line{
  white-space: pre-line;
}
</style>
